import React from "react";
import { Card } from "@mui/material";
import "./Payment.scss";
import { Link } from "react-router-dom";
import mark from "../../check-mark.png";
import { HashLink as Anchor } from "react-router-hash-link";
import { useAppSelector } from "../../redux-store/store";
export const Payment = () => {
  // const [isDisabled, setIsDisabled] = useState(true);
  const auth = useAppSelector((state) => state.registrationReducer.auth);
  const tariffs = useAppSelector((state) => state.tariffsReducer.data);
  const getTariff = (key: string) => (tariffs || []).find((t) => t.key === key);
  return (
    <div id={"tarif"} className={"backColor"}>
      <div className={"backImageKosmosPay"}></div>
      <div className={"allPay"}>
        <span className={"spanTarifGlav"}>тарифы</span>
        <p className={"tarifText"}>Измени свою жизнь к лучшему уже сейчас</p>
        <div className={"listPay"}>
            <Card className={"card"}>
              <span className={"spanPay"}>{getTariff("3months")?.name || "Матрица на 3 месяца"}</span>
              <div className={"divTarif"}>
                <div className={"divPrice"}>
                  {getTariff("3months")?.oldPrice ? (<><span className={"price"} style={{ textDecoration: "line-through" }}>{getTariff("3months")?.oldPrice}</span><span className={"tarifRubl"}>рублей</span></>) : null}
                  <span className={"price"}>{getTariff("3months")?.price ?? 1290}</span>
                  <br />
                  <span className={"tarifRubl"}>рублей</span>
                </div>
                <ul>
                  {(getTariff("3months")?.description || "Расшифровка детской матрицы;Расшифровка совместимости;Полная расшифровка Матрицы;Количество дат к проверке не ограничено;Доступ НА 3 МЕСЯЦА").split(";").map((item, idx) => (
                    <li className={"ulPay"} key={idx}>
                      <img src={mark} alt="" className={"ic"} />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
              <Link
                className={"baton"}
                to={"/pay"}
                style={{ width: "100%", fontWeight: "bold", padding: 10, fontSize: 16, textAlign: "center" }}
                // state={{ name: "Матрица на месяц", price: 100 }}
                state={{ name: getTariff("3months")?.name || "Матрица на 3 месяца", price: (getTariff("3months")?.price ?? 1290) * 100 }}
              >
                Приобрести
              </Link>
            </Card>
            <Card className={"card"}>
              <span className={"spanPay"}>{getTariff("year")?.name || "Матрица на год"}</span>
              <div className={"divTarif"}>
                <div className={"divPrice"}>
                  {getTariff("year")?.oldPrice ? (<><span className={"price"} style={{ textDecoration: "line-through" }}>{getTariff("year")?.oldPrice}</span><span className={"tarifRubl"}>рублей</span></>) : null}
                  <span className={"price"}>{getTariff("year")?.price ?? 2790}</span>
                  <br />
                  <span className={"tarifRubl"}>рублей</span>
                </div>
                <ul>
                  {(getTariff("year")?.description || "Расшифровка детской матрицы;Расшифровка совместимости;Полная расшифровка Матрицы;Количество дат к проверке не ограничено;Доступ НА 1 ГОД").split(";").map((item, idx) => (
                    <li className={"ulPay"} key={idx}>
                      <img src={mark} alt="" className={"ic"} />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
              <Link
                className={"baton"}
                to={"/pay"}
                style={{ width: "100%", fontWeight: "bold", padding: 10, fontSize: 16, textAlign: "center" }}
                state={{ name: getTariff("year")?.name || "Матрица на год", price: (getTariff("year")?.price ?? 2790) * 100 }}
              >
                Приобрести
              </Link>
            </Card>

            <Card className={"card"}>
              <span className={"spanPay"}>{getTariff("forever")?.name || "Раз и навсегда"}</span>
              <div className={"divTarif"}>
                <div className={"divPrice"}>
                  {getTariff("forever")?.oldPrice ? (<><span className={"price"} style={{ textDecoration: "line-through" }}>{getTariff("forever")?.oldPrice}</span><span className={"tarifRubl"}>рублей</span></>) : null}
                  <span className={"price"}>{getTariff("forever")?.price ?? 5990}</span>
                  <br />
                  <span className={"tarifRubl"}>рублей</span>
                </div>
                <ul>
                  {(getTariff("forever")?.description || "Расшифровка детской матрицы;Расшифровка совместимости;Полная расшифровка Матрицы;Количество дат к проверке не ограничено;Доступ НАВСЕГДА").split(";").map((item, idx) => (
                    <li className={"ulPay"} key={idx}>
                      <img src={mark} alt="" className={"ic"} />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
              <Link
                className={"baton"}
                to={"/pay"}
                style={{ width: "100%", fontWeight: "bold", padding: 10, fontSize: 16, textAlign: "center" }}
                state={{ name: getTariff("forever")?.name || "Вместе и навсегда", price: (getTariff("forever")?.price ?? 5990) * 100 }}
              >
                Приобрести
              </Link>
            </Card>
            <Card className={"card"}>
              <span className={"spanPay"}>{getTariff("trial")?.name || "Пробный"}</span>
              <div className={"divTarif"}>
                <div className={"divPrice"}>
                  {getTariff("trial")?.oldPrice ? (<><span className={"price"} style={{ textDecoration: "line-through" }}>{getTariff("trial")?.oldPrice}</span><span className={"tarifRubl"}>рублей</span></>) : null}
                  <span className={"price"}>{getTariff("trial")?.price ?? 290}</span>
                  <br />
                  <span className={"tarifRubl"}>рублей</span>
                </div>
                <ul>
                  {(getTariff("trial")?.description || "1 Расшифровка Матрицы судьбы;1 Расшифровка совместимости;1 Расшифровка Детской Матрицы").split(";").map((item, idx) => (
                    <li className={"ulPay"} key={idx}>
                      <img src={mark} alt="" className={"ic"} />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
              <Link
                className={"baton"}
                to={"/pay"}
                style={{ width: "100%", fontWeight: "bold", padding: 10, fontSize: 16, textAlign: "center" }}
                state={{ name: getTariff("trial")?.name || "Пробный", price: (getTariff("trial")?.price ?? 290) * 100 }}
              >Приобрести
              </Link>
            </Card>


            <Card className={"card"}>
              <span className={"spanPay"}>{getTariff("calculator")?.name || "Свой калькулятор по Матрице судьбы"}</span>
              <div className={"divTarif"}>
                <ul>
                  {(getTariff("calculator")?.description || "Ваш индивидуальный калькулятор для расчета Матрицы Судьбы;Делись своей ссылкой на калькулятор и направляй клиентов в свои социальные сети").split(";").map((item, idx) => (
                    <li className={"ulPay"} key={idx}>
                      <img src={mark} alt="" className={"ic"} />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
              <a
                style={{ width: "100%", fontWeight: "bold", padding: 10, fontSize: 16, textAlign: "center" }}
                className={"baton"}
                href="https://www.wildberries.ru/seller/1231179"
                target="_blank"
                rel="noopener noreferrer"
              >
                Перейти в магазин
              </a>
            </Card>

            <Card className={"card"}>
              <span className={"spanPay"}>{getTariff("edu_programs")?.name || "Программы дополнительного профессионального обучения"}</span>
              <div className={"divTarif"}>
                <ul>
                  {(getTariff("edu_programs")?.description || "Матрица Судьбы;Родология;Таро").split(";").map((item, idx) => (
                    <li className={"ulPay"} key={idx}>
                      <img src={mark} alt="" className={"ic"} />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
              <a
                className={"baton"}
                href="https://www.ozon.ru/seller/matritsa-dushi/products/?__rr=1&abt_att=1&miniapp=seller_1228272&short=ZJ4usGt"
                target="_blank"
                rel="noopener noreferrer"
                style={{ width: "100%", fontWeight: "bold", padding: 10, fontSize: 16, textAlign: "center" }}
              >
                Перейти в магазин
              </a>
            </Card>
        </div>
        <p
          className={"pVajno"}
          style={{
            textAlign: "start",
            color: "red",
            fontSize: 25,
            marginBottom: 50
          }}
        >
          Все приобретенные даты по подписке будут доступны вам навсегда в разделе «История поиска матриц».
          <br />
          При повторном приобретении тарифа «Пробный» количество расшифровок прибавляется к уже ранее приобретенным.
          <br />
          При повторном приобретении тарифа «Матрица на 3 месяца» 3 месяца прибавляются к ранее приобретенным месяцам.
          <br />
          При приобретении тарифа «Раз и навсегда» вы получаете доступ бессрочно.
        </p>
      </div>
    </div>
  );
};
